/**
 * @file common function
 */

/**
 * 1、获取日期格式输出
 * @param  {Date}   time   时间
 * @param  {string} format 输出格式，要求必须含有yyyy,mm,dd
 * @return {string}        默认返回yyyymmdd格式时间
 */
export function getTimeStr(time, format = 'yyyy-MM-dd HH:mm:ss') {
    if (typeof time === 'string' ||//eslint-disable-line
        typeof time === 'number') {
        time = new Date(time);
        return format
            .replace('yyyy', time.getFullYear())
            .replace('MM', leftpad(time.getMonth() + 1, 2, '0'))
            .replace('dd', leftpad(time.getDate(), 2, '0'))
            .replace('HH', leftpad(time.getHours(), 2, '0'))
            .replace('mm', leftpad(time.getMinutes(), 2, '0'))
            .replace('ss', leftpad(time.getSeconds(), 2, '0'));
    }
    return '';
}

function leftpad(str, len, ch = ' ') {
    str = str + '';
    len = len - str.length;
    if (len <= 0) {
        return str;
    }
    ch = ch + '';
    let pad = '';
    while (len) {
        if (len & 1) {
            pad += ch;
        }
        len >>= 1;
        ch += ch;
    }
    return pad + str;
}


/**
 * 数组对象转化单一数组
 * @param  {Array}  array  目标数组
 * @param  {string} key    键
 * @return {Array}  total  新数组
 */
export function arrayToSingleArr(array, key) {
    return array.reduce((total, current) => {
        total.push(current[key]);
        return total;
    }, []);
}

/**
 * 清除表单内容
 * @param  {Object}   object   目标对象
 * @param  {Array}   extra   额外处理的键
 */
export function clearObject(object, extra = []) {
    for (const key in object) {
        if (object.hasOwnProperty(key) && !extra.includes(key)) {
            object[key] = '';
        }
    }
}


export function setObject(target, object) {
	for(let k in target) {
		target[k] = object[k];
	}
}
